module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "#3F3FFF",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("My Tasks")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadTasks()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('v-list-item', {
      key: item.title,
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.actionOnTask(item.action, item.postID)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                      " + _vm._s(item.text) + "\n                  ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.items.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54c07f39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/ContentStrategistTasks.vue
// module id = 2130
// module chunks = 0